import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Sanitizer, SecurityContext } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministratorService } from 'src/app/core/servicie/administrador.service';
import { CustomerService } from 'src/app/core/servicie/customer.service';
import { IParametric } from 'src/app/shared/interfaces/parametric.interface';

import { environment } from 'src/environments/environment';
import { Video } from 'src/app/shared/interfaces/video.interface';
import { SupportParametric } from 'src/app/shared/interfaces/supporarea';

@Component({
  selector: 'app-learn-to-use-the-titan-app',
  templateUrl: './learn-to-use-the-titan-app.component.html',
  styleUrls: ['./learn-to-use-the-titan-app.component.scss']
})
export class LearnToUseTheTitanAppComponent implements OnInit {
  urlBlobStorage: string= environment.blobstorage;
  listAnswer:SupportParametric[]=[];
  videos: Video[] = [
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-CONTESTAR-LAS-PREGUNTAS-DEL-MEMORY-JOGGER14.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/uMrLyemtOww?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MEMORYJOGGER',
      title:'Cómo contestar las preguntas del Memory Jogger en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-ACCEDER-AL-TUTORIAL-DEL-MEMORY-JOGGER6.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/5cDVHPgx89I?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MEMORYJOGGER',
      title:'Cómo acceder al tutorial del Memory Jogger y a las preguntas finalizadas en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-COMPARTIR-LA-REVISTA9.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/fiCl4VW_8ns?autoplay=1&mute=1'),
      isPlaying: false,
      type:'SHARE',
      title:'Cómo compartir la revista Recomendaciones de Confianza desde la Titán App​'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-COMPARTIR-OFERTAS11.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/x3sK1Cnac18?autoplay=1&mute=1'),
      isPlaying: false,
      type:'SHARE',
      title:'Cómo compartir ofertas desde la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-COMPARTIR-CONTENIDOS8.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/6cQs97rnsMs?autoplay=1&mute=1'),
      isPlaying: false,
      type:'SHARE',
      title:'Cómo compartir contenidos desde la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-COMPARTIR-MENSAJES10.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/JLH1zCLHIIE?autoplay=1&mute=1'),
      isPlaying: false,
      type:'SHARE',
      title:'Cómo compartir mensajes y anuncios desde la Titán App'
    },


    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-IMPORTAR-CONTACTOS.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/QsUiL5eU_CM?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo importar mis contactos en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-CREAR-UN-CONTACTO.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/dTY1QDaSkAs?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo crear un contacto en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-CONSULTAR-UN-CONTACTO.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/RdNQIEC0_ZE?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo consultar un contacto en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-EDITAR-UN-CONTACTO.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/UGo_yiQ1uaU?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo editar un contacto en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_PARA-QUE-SIRVE-LA-FUNCION-SOLICITAR-DATOS.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/NXRcrYvrArY?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Para qué sirve la función Solicitar datos de un contacto a un tercero en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-FORMALIZAR-EL-PACTO-DE-CONFIANZA.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/TNc3QWBBT5E?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo filtrar tus contactos en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-MODIFICAR-ATRIBUTOS-DE-UN-CONTACTO.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/2_L1Zuc_U0A?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo modificar atributos de un contacto masivamente en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_COMO-FILTRAR-CONTACTOS.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/x7hiZuN3_FY?autoplay=1&mute=1'),
      isPlaying: false,
      type:'MYCONTACTS',
      title:'Cómo formalizar el Pacto de confianza en la Titán App'
    },

    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-EDITAR-LOS-DATOS-DEL-PERFIL16.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/w3opo0bKMe8?autoplay=1&mute=1'),
      isPlaying: false,
      type:'PROFILE',
      title:'Cómo editar los datos de mi perfil de la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-REALIZAR-AJUSTES27.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/6-uKJ_qTBT4?autoplay=1&mute=1'),
      isPlaying: false,
      type:'PROFILE',
      title:'Cómo realizar ajustes a mi cuenta de la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-ENViAR-UNA-RECOMENDACIoN18.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/j7Zk0JMxBrc?autoplay=1&mute=1'),
      isPlaying: false,
      type:'PROFILE',
      title:'Cómo enviar una recomendación de mejora para la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-ACCEDER-AL-SOPORTE5.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/aazYpL3U9tc?autoplay=1&mute=1'),
      isPlaying: false,
      type:'PROFILE',
      title:'Cómo acceder al soporte de la Titán App'
    },

    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-AGREGAR-UN-SUEnO7.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/S5yGvhcEcY8?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo agregar mi sueño en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-MODIFICAR-UN-SUEnO26.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/yEaSHx8XO8g?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo modificar mi sueño en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-SOLICITAR-UNA-TRANSFERENCIA30.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/bxdxmJXC2c0?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo puedo solicitar una transferencia de dinero desde la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-SOLICITAR-UN-INFORME-O-EXTRACTO29.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/hIaj1EhhCCw&t?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo puedo solicitar un informe o extracto de mis ganancias desde la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-VER-LAS-NOTIFICACIONES31.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/6ifpCrniVxQ?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo ver las notificaciones en la Titán App'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-VER-LOS-EVENTOS-DEL-SPRINT32.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/cgxZwhXm4JU?autoplay=1&mute=1'),
      isPlaying: false,
      type:'OTHERFUNCTION',
      title:'Cómo ver los eventos del Sprint en la Titán App'
    },

    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-INGRESAR-A-LA-TITaN-APP24.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/F7eB44gyxgQ?autoplay=1&mute=1'),
      isPlaying: false,
      type:'REGISTERANDLOGIN',
      title:'Cómo ingreso a la Titán App por primera vez'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_ACCEDE-A-LA-TITaN-APP1.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/cOC0_k9AAXM?autoplay=1&mute=1'),
      isPlaying: false,
      type:'REGISTERANDLOGIN',
      title:'Accede a la Titán App y conoce el menú principal'
    },
    {
      thumbnailUrl: `${this.urlBlobStorage}Learn-to-use-the-Titan-App/VideoImages/TTA-INDUCCION_CoMO-RECUPERAR-LA-CONTRASEnA28.webp`,
      videoUrl: this.getSafeUrl('https://www.youtube.com/embed/CbJBEOk_eAE?autoplay=1&mute=1'),
      isPlaying: false,
      type:'REGISTERANDLOGIN',
      title:'Cómo recupero la contraseña de la Titán App'
    }
     
  ];
  selectOptions: any;
 
  constructor(private sanitizer: DomSanitizer,
    private administratorService:AdministratorService,
    private route: ActivatedRoute,
    private customerService:CustomerService,
    private router: Router) {
      
  }
  ngOnInit(): void {
    this.administratorService.getSupportArea("Es").subscribe(dataThematic=>{
      this.listAnswer=dataThematic;
      console.log(this.listAnswer);
      
     
    });
  
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  playVideo(video: Video): void { 
    console.log('Activando video de YouTube');
    video.isPlaying = true;
  }
}


@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}